import clsx from 'clsx';
import { withMask } from 'use-mask-input';

import { AcceptIcon } from '@/assets/react-icons/AcceptIcon';
import { EditIcon } from '@/assets/react-icons/EditIcon';
import { Button } from '@/components/Button';
import { Input } from '@/components/Input';
import { Loader } from '@/components/Loader';
import { Text } from '@/components/Text';

import styles from './TaxIdentificationNumberInfo.module.scss';

type Props = {
  className?: string;
  error?:
    | {
        message?: string;
      }
    | undefined;
  isEditBlockMode: boolean;
  isLoading?: boolean;
  onChange: (value: string) => void;
  onEdit: () => void;
  onSave: () => void;
  value: string;
};

export const TaxIdentificationNumberInfo = ({
  className,
  error,
  isEditBlockMode,
  isLoading,
  onChange,
  onEdit,
  onSave,
  value,
}: Props) => {
  const tinMask = withMask('9999999999');

  return (
    <div className={clsx(styles.wrapper, !isEditBlockMode && styles.isSaved, className)}>
      <div className={styles['identification-left']}>
        <Text type='p2'>Дані ідентифікаційного номера платника податків</Text>
        <Text color='text-gray' style={{ display: 'flex' }} type='p3'>
          Введіть дані індефікаційного номера платника податків фактичного власника ділянки
        </Text>
        {isEditBlockMode ? (
          <Input
            error={error}
            onChange={(e) => onChange(e.target.value)}
            placeholder='№ ІПН'
            ref={tinMask}
            value={value}
          />
        ) : (
          <div className={styles.validTextRow}>
            <Text color='text-gray' type='p3'>
              № ІПН:
            </Text>{' '}
            <Text color='black' type='p3'>
              {value}
            </Text>
          </div>
        )}
      </div>
      <div className={styles['identification-right']}>
        {isEditBlockMode ? (
          <div className={styles.btnSaveCont}>
            {isLoading && <Loader />}
            <Button disabled={isLoading} icon={<AcceptIcon />} onClick={onSave} small>
              Зберегти
            </Button>
          </div>
        ) : (
          <Button icon={<EditIcon />} onClick={onEdit} small>
            Редагувати
          </Button>
        )}
      </div>
    </div>
  );
};
